export interface ISystemPointHistory {
    historyExists: boolean;
    lastTimestamp: Date;
    firstTimestamp: Date;
}

export class SystemPointHistory implements ISystemPointHistory {
    historyExists: boolean;
    lastTimestamp: Date;
    firstTimestamp: Date;

    constructor(historyExists: boolean,
        lastTimestamp: Date,
        firstTimestamp: Date) {
        this.historyExists = historyExists;
        this.lastTimestamp = lastTimestamp;
        this.firstTimestamp = firstTimestamp;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-point-history.ts
 **/